import SlideshowIcon from '@material-ui/icons/Slideshow';
import { Fab } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import React, { useContext } from 'react';
import './List.scss';
import { FileContext } from 'context/FileContext';
import ImageList from 'component/ImageList';
import FileUpload from 'component/FileUpload';

function List(): JSX.Element {
  const history = useHistory();
  const fileContext = useContext(FileContext);

  return (
    <section className="page list-page">
      <ImageList files={fileContext.files} />
      <FileUpload onChangeFile={fileContext.onChangeFile} className="list-file-upload" />
      <Fab
        variant="extended"
        className="album-btn"
        onClick={() => history.push('/active')}
      >
        <SlideshowIcon className="album-btn-icon" />
        앨범 만들기
      </Fab>
    </section>
  );
}

export default List;
